import { Entity } from '@adornis/baseql/decorators.js';
import { UserStammdaten } from '../../entities/stammdaten.js';
import type { RegistrationStammdatenPlugin } from '../plugin-types.js';

// ===== Claudia Koch =====

export const ckRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::ck',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new CKStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(CKStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => CKStammdaten,
};

@Entity()
export class CKStammdaten extends UserStammdaten {
  static override _class = 'CKStammdaten';

  override getTranslationNamespace() {
    return 'st';
  }
}
